import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useGetProductGroupsForSourcingEventQuery, type BuyerBidDetailDto } from "../../../autogen/bff-api";
import { BidProductTables, toBidProductGroups } from "../../../common/products/BidProductTables";

export const ProductsTab = ({ detail }: { detail: BuyerBidDetailDto }) => {
  const { t } = useTranslation();
  const { eventId } = useParams();
  const { data } = useGetProductGroupsForSourcingEventQuery(
    { sourcingEventId: eventId ?? "" },
    { skip: !eventId },
  );
  const bidProducts = detail.bid.products ?? [];

  if (bidProducts.length === 0) {
    return <Text color="smMuted">{t("The supplier has not filled in any product prices.")}</Text>;
  }

  return (
    <Box bg="smBackground" rounded="xl" border="1px solid" borderColor="smBorder" p={{ base: "4", md: "6" }}>
      <BidProductTables groups={toBidProductGroups(data?.productGroups ?? [], bidProducts)} />
    </Box>
  );
};
